var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('header-datasheets-overview',{attrs:{"classification":this.classification,"category":this.category}},[_c('datasheets-table',{attrs:{"datasheets":_vm.datasheets}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }